export function generateCtPnsReport(frmData, currentUser) {
  let report = "";
  const impression = [];

  // Hardcoded text dictionary from text_hrct_chest.json
  const text = {
    PnsFrontalPeumatizationR: "Pneumatization of right frontal sinus is {1}.",
    PnsFrontalMusocalthickingR: "{1} mucosal thickening seen in right frontal sinus",
    PnsFrontalPeumatizationL: "Pneumatization of left frontal sinus is {1}.",
    PnsFrontalMusocalthickingL: "{1} mucosal thickening seen in left frontal sinus",
    PnsmaxillaryPeumatizationR: "Pneumatization of right maxillary sinus is {1}.",
    PnsmaxillaryMusocalthickingR: "{1} mucosal thickening seen in right maxillary sinus.",
    PnsMaxillaryRightOsteomeatalUnitText: "Osteomeatal unit is {1} on right side.",
    PnsmaxillaryPeumatizationL: "Pneumatization of left maxillary sinus is {1}.",
    PnsmaxillaryMusocalthickingL: "{1} mucosal thickening seen in left maxillary sinus",
    PnsMaxillaryLeftOsteomeatalUnitText: "Osteomeatal unit is {1} on left side.",
    PnsEthmoidalRightPneumatizationText: "Pneumatization of right ethmoidal sinus is {1}.",
    PnsEthmoidalRightMusocalThickingText: "{1} mucosal thickening seen in right ethmoidal sinus",
    PnsEthmoidalRightSeptaeText: "{1} of septae of right ethomiod sinus is seen",
    PnsEthmoidalLeftPneumatizationText: "Pneumatization of left ethmoidal sinus is {1}.",
    PnsEthmoidalLeftMusocalThickingText: "{1} mucosal thickening seen in left ethmoidal sinus",
    PnsEthmoidalLeftSeptaeText: "{1} of septae of left ethomiod sinus is seen",
    PnsSphenoidRightPneumatizationText: "Pneumatization of right sphenoid sinus is {1}.",
    PnsSphenoidRightMusocalThickingText: "{1} mucosal thickening seen in right sphenoid sinus",
    PnsSphenoidLeftPneumatizationText: "Pneumatization of left sphenoid sinus is {1}.",
    PnsSphenoidLeftMusocalThickingText: "{1} mucosal thickening seen in left sphenoid sinus",
    TurbinatesNasalRightConchaText: "{1} type concha bullosa seen on right middle turbinates.",
    TurbinatesNasalLeftConchaText: "{1} type concha bullosa seen on left middle turbinates.",
    MiscellaneousTypeKerosText: "Type {1} KEROs depth of olfactory fossa seen.",
    MiscellaneousTypeOpticNerveText: "Type {1} optic nerve seen.",
    MiscellaneousAdenoidyesText: "Adenoid hypertrophy is seen {1}.",
    OsteomaText: "Osteoma seen in right {1} sinus measuring {2}mm.",
    OsteomaText1: "Osteoma seen in left {1} sinus measuring {2}mm.",
    MucoceleText: "Mucocele seen in right {1} sinus measuring {2}mm.",
    MucoceleText1: "Mucocele seen in left {1} sinus measuring {2}mm."
  };

  if (frmData.NameTextFR4 && frmData.IDTextFR4 && frmData.AgeTextFR4 && frmData.GenderTextFR4) {
    report += `<pre><b><header><table><tr><td>Name: ${frmData.NameTextFR4}</td><td>Patient ID: ${frmData.IDTextFR4}</td><td>Age: ${frmData.AgeTextFR4}</td></tr><tr><td>Gender: ${frmData.GenderTextFR4}</td><td>Test date: ${frmData.TestDateTextFR4}</td><td>Report date: ${frmData.ReportDateTextFR4}</td></tr><tr><td>Referral Dr: ${frmData.ReferralDrTextFR4 || ""}</td><td colspan="2">Report time: ${frmData.ReporttimeTextFR4 || ""}</td></tr></table></header></b></pre>`;
  }

  if (frmData.Normalsinus) {
    report += "<h5><center><strong><u>LOW DOSE CT REPORT - PARANASAL SINUSES</u></strong></center></h5><h5><strong><u>TECHNIQUE:</u></strong> Sequential scans of paranasal sinuses were done in both coronal and axial planes without intravenous contrast.</h5><h5><strong><u>OBSERVATION:</u></strong></h5>";
  } else if (frmData.PnsSinuses || frmData.NasalCavity || frmData.Miscellaneous) {
    report += "<h5><center><strong><u>LOW DOSE CT REPORT - PARANASAL SINUSES</u></strong></center></h5><h5><strong><u>OBSERVATION:</u></strong></h5>";
  }

  // Normal
  if (frmData.Normalsinus) {
    report += "<p>The frontal sinus is normal on both sides. Frontal recess is patent on both sides.<br><br>Right maxillary sinus is normal. Osteomeatal unit is patent.<br><br>Left maxillary sinus is normal. Osteomeatal unit is patent.<br><br>The ethmoidal cells are normal.<br><br>The sphenoid sinus and spheno-ethmoid recess are normal.<br><br>No evidence of osteitis, bone sclerosis or bone erosion is visualized.<br><br>The nasal septum is within normal limits.<br><br>The nasal turbinates appear normal.<br><br>The nasopharynx is normal.<br><br>Mastoid air cells are normal. No evidence of soft tissue density in both middle ears.<br><br>No adenoid hypertrophy.</p>";
  }

  // Sinuses
  if (frmData.PnsSinuses) {
    // Frontal
    if (frmData.PnsFrontal) {
      if (frmData.PnsFrontalRight) {
        if (frmData.PnsFrontalRightPneumatization && frmData.PnsFrontalRightPneumatizationtype) {
          const txt = text.PnsFrontalPeumatizationR.replace("{1}", frmData.PnsFrontalRightPneumatizationtype);
          report += `<p><b>${txt}</b></p>`; impression.push(`<p><b>${txt}</b></p>`);
        }
        if (frmData.PnsFrontalRightMusocalThicking && frmData.PnsFrontalRightMusocalThickingType) {
          let txt = text.PnsFrontalMusocalthickingR.replace("{1}", frmData.PnsFrontalRightMusocalThickingType);
          if (frmData.PnsFrontalRightHyperdense) txt += " with hyperdense.";
          report += `<p><b>${txt}</b></p>`; impression.push(`<p><b>${txt}</b></p>`);
        }
        if (frmData.PnsFrontalRightAirFluid) {
          report += "<p><b>Air fluid levels seen in right frontal sinus.</b></p>"; impression.push("<p><b>Air fluids level seen in right frontal sinus.</b></p>");
        }
        if (frmData.PnsFrontalRightFrontoEthmoid && frmData.PnsFrontalRightFrontoEthmoidType) {
          const dict = {'patent': 'fronto-ethmoid recess is patent in right frontal sinus. ', 'partial narrowing': 'There is partial narrowing of right fronto-ethmoid recess. ', 'complete occlusion': 'Complete occlusion of right fronto-ethmoid recess seen.'};
          const val = dict[frmData.PnsFrontalRightFrontoEthmoidType];
          if (val) { report += `<p><b>${val}</b></p>`; impression.push(`<p><b>${val}</b></p>`); }
        }
        if (frmData.PnsFrontalRightBonyErosions) {
          report += "<p><b>Bony erosion seen on right side of frontal sinus.</b></p>"; impression.push("<p><b>Bony erosion seen on right side of frontal sinus.</b></p>");
        }
      }
      if (frmData.PnsFrontalLeft) {
        if (frmData.PnsFrontalLeftPneumatization && frmData.PnsFrontalLeftPneumatizationtype) {
          const txt = text.PnsFrontalPeumatizationL.replace("{1}", frmData.PnsFrontalLeftPneumatizationtype);
          report += `<p><b>${txt}</b></p>`; impression.push(`<p><b>${txt}</b></p>`);
        }
        if (frmData.PnsFrontalLeftMusocalThicking && frmData.PnsFrontalLeftMusocalThickingType) {
          let txt = text.PnsFrontalMusocalthickingL.replace("{1}", frmData.PnsFrontalLeftMusocalThickingType);
          if (frmData.PnsFrontalLeftHyperdense) txt += " with hyperdense.";
          report += `<p><b>${txt}</b></p>`; impression.push(`<p><b>${txt}</b></p>`);
        }
        if (frmData.PnsFrontalLeftAirFluid) {
          report += "<p><b>Air fluid levels seen in left frontal sinus.</b></p>"; impression.push("<p><b>Air fluid levels seen in left frontal sinus.</b></p>");
        }
        if (frmData.PnsFrontalLeftFrontoEthmoid && frmData.PnsFrontalLeftFrontoEthmoidType) {
          const dict = {'patent': 'fronto-ethmoid recess is patent in left frontal sinus. ', 'partial narrowing': 'There is partial narrowing of left fronto-ethmoid recess. ', 'complete occlusion': 'Complete occlusion of left fronto-ethmoid recess seen.'};
          const val = dict[frmData.PnsFrontalLeftFrontoEthmoidType];
          if (val) { report += `<p><b>${val}</b></p>`; impression.push(`<p><b>${val}</b></p>`); }
        }
        if (frmData.PnsFrontalLeftBonyErosions) {
          report += "<p><b>Bony erosion seen on left side of frontal sinus.</b></p>"; impression.push("<p><b>Bony erosion seen on left side of frontal sinus.</b></p>");
        }
      }
    }

    // Maxillary
    if (frmData.PnsMaxillary) {
      if (frmData.PnsMaxillaryRight) {
        if (frmData.PnsMaxillaryRightPneumatization && frmData.PnsmaxillaryRightPneumatizationtype) {
          const txt = text.PnsmaxillaryPeumatizationR.replace("{1}", frmData.PnsmaxillaryRightPneumatizationtype);
          report += `<p><b>${txt}</b></p>`; impression.push(`<p><b>${txt}</b></p>`);
        }
        if (frmData.PnsMaxillaryRightMusocalThicking && frmData.PnsMaxillaryRightMusocalThickingType) {
          let txt = text.PnsmaxillaryMusocalthickingR.replace("{1}", frmData.PnsMaxillaryRightMusocalThickingType);
          if (frmData.PnsMaxillaryRightHyperdense) txt += " with hyperdense.";
          report += `<p><b>${txt}</b></p>`; impression.push(`<p><b>${txt}</b></p>`);
        }
        if (frmData.PnsMaxillaryRightAirFluid) {
          report += "<p><b>Air fluid levels seen in right maxillary sinus.</b></p>"; impression.push("<p><b>Air fluid levels seen in right maxillary sinus.</b></p>");
        }
        if (frmData.PnsMaxillaryRightOsteomeatalUnit && frmData.PnsMaxillaryRightOsteomeatalUnitType) {
          const txt = text.PnsMaxillaryRightOsteomeatalUnitText.replace("{1}", frmData.PnsMaxillaryRightOsteomeatalUnitType);
          report += `<p><b>${txt}</b></p>`; impression.push(`<p><b>${txt}</b></p>`);
        }
        if (frmData.PnsMaxillaryRightBonyErosions) {
          report += "<p><b>Erosions seen in bony walls of right maxillary sinus.</b></p>"; impression.push("<p><b>Erosions seen in bony walls of right maxillary sinus.</b></p>");
        }
        if (frmData.PnsMaxillaryRightAccessoryOstia) {
          report += "<p><b>Accessory ostia of right maxillary sinus seen.</b></p>"; impression.push("<p><b>Accessory ostia of right maxillary sinus seen.</b></p>");
        }
      }
      if (frmData.PnsMaxillaryLeft) {
        if (frmData.PnsMaxillaryLeftPneumatization && frmData.PnsmaxillaryLeftPneumatizationtype) {
          const txt = text.PnsmaxillaryPeumatizationL.replace("{1}", frmData.PnsmaxillaryLeftPneumatizationtype);
          report += `<p><b>${txt}</b></p>`; impression.push(`<p><b>${txt}</b></p>`);
        }
        if (frmData.PnsMaxillaryLeftMusocalThicking && frmData.PnsMaxillaryLeftMusocalThickingType) {
          let txt = text.PnsmaxillaryMusocalthickingL.replace("{1}", frmData.PnsMaxillaryLeftMusocalThickingType);
          if (frmData.PnsMaxillaryLeftHyperdense) txt += " with hyperdense.";
          report += `<p><b>${txt}</b></p>`; impression.push(`<p><b>${txt}</b></p>`);
        }
        if (frmData.PnsMaxillaryLeftAirFluid) {
          report += "<p><b>Air fluid levels seen in left maxillary sinus.</b></p>"; impression.push("<p><b>Air fluid levels seen in left maxillary sinus.</b></p>");
        }
        if (frmData.PnsMaxillaryLeftOsteomeatalUnit && frmData.PnsMaxillaryLeftOsteomeatalUnitType) {
          const txt = text.PnsMaxillaryLeftOsteomeatalUnitText.replace("{1}", frmData.PnsMaxillaryLeftOsteomeatalUnitType);
          report += `<p><b>${txt}</b></p>`; impression.push(`<p><b>${txt}</b></p>`);
        }
        if (frmData.PnsMaxillaryLeftBonyErosions) {
          report += "<p><b>Erosions seen in bony walls of left maxillary sinus.</b></p>"; impression.push("<p><b>Erosions seen in bony walls of left maxillary sinus.</b></p>");
        }
        if (frmData.PnsMaxillaryLeftAccessoryOstia) {
          report += "<p><b>Accessory ostia of left maxillary sinus seen.</b></p>"; impression.push("<p><b>Accessory ostia of left maxillary sinus seen.</b></p>");
        }
      }
    }

    // Ethmoidal
    if (frmData.PnsEthmoidal) {
      if (frmData.PnsEthmoidalRight) {
        if (frmData.PnsEthmoidalRightPneumatization && frmData.PnsEthmoidalRightPneumatizationtype) {
          const txt = text.PnsEthmoidalRightPneumatizationText.replace("{1}", frmData.PnsEthmoidalRightPneumatizationtype);
          report += `<p><b>${txt}</b></p>`; impression.push(`<p><b>${txt}</b></p>`);
        }
        if (frmData.PnsEthmoidalRightMusocalThicking && frmData.PnsEthmoidalRightMusocalThickingType) {
          let txt = text.PnsEthmoidalRightMusocalThickingText.replace("{1}", frmData.PnsEthmoidalRightMusocalThickingType);
          if (frmData.PnsEhtmoidalRightHyperdense) txt += " with hyperdense.";
          report += `<p><b>${txt}</b></p>`; impression.push(`<p><b>${txt}</b></p>`);
        }
        if (frmData.PnsEhtmoidalRightAirFluid) {
          report += "<p><b>Air fluid levels seen in right ethmoidal sinus.</b></p>"; impression.push("<p><b>Air fluids level seen in right ethmoidal sinus.</b></p>");
        }
        if (frmData.PnsEthmoidalRightBonyErosions) {
          report += "<p><b>Erosions seen in bony walls of right ethmoidal sinus.</b></p>"; impression.push("<p><b>Erosions seen in bony walls of right ethmoidal sinus.</b></p>");
        }
        if (frmData.PnsEthmoidalRightSeptae && frmData.PnsEthmoidalRightSeptaeType) {
          const txt = text.PnsEthmoidalRightSeptaeText.replace("{1}", frmData.PnsEthmoidalRightSeptaeType);
          report += `<p><b>${txt}</b></p>`; impression.push(`<p><b>${txt}</b></p>`);
        }
        if (frmData.PnsEhtmoidalRightVarient) {
          if (frmData.PnsEhtmoidalRightVarientHaller) { report += "<p><b>Haller cells present on right side.</b></p>"; impression.push("<p><b>Haller cells present on right side.</b></p>"); }
          if (frmData.PnsEhtmoidalRightVarientOnodi) { report += "<p><b>Onodi cells present on right side.</b></p>"; impression.push("<p><b>Onodi cells present on right side.</b></p>"); }
        }
      }
      if (frmData.PnsEthmoidalLeft) {
        if (frmData.PnsEthmoidalLeftPneumatization && frmData.PnsEthmoidalLeftPneumatizationtype) {
          const txt = text.PnsEthmoidalLeftPneumatizationText.replace("{1}", frmData.PnsEthmoidalLeftPneumatizationtype);
          report += `<p><b>${txt}</b></p>`; impression.push(`<p><b>${txt}</b></p>`);
        }
        if (frmData.PnsEthmoidalLeftMusocalThicking && frmData.PnsEthmoidalLeftMusocalThickingType) {
          let txt = text.PnsEthmoidalLeftMusocalThickingText.replace("{1}", frmData.PnsEthmoidalLeftMusocalThickingType);
          if (frmData.PnsEhtmoidalLeftHyperdense) txt += " with hyperdense.";
          report += `<p><b>${txt}</b></p>`; impression.push(`<p><b>${txt}</b></p>`);
        }
        if (frmData.PnsEhtmoidalLeftAirFluid) {
          report += "<p><b>Air fluid level seen in left ethmoidal sinus.</b></p>"; impression.push("<p><b>Air fluid level seen in left ethmoidal sinus.</b></p>");
        }
        if (frmData.PnsEthmoidalLeftBonyErosions) {
          report += "<p><b>Erosions seen in bony walls of left ethmoidal sinus.</b></p>"; impression.push("<p><b>Erosions seen in bony walls of left ethmoidal sinus.</b></p>");
        }
        if (frmData.PnsEthmoidalLeftSeptae && frmData.PnsEthmoidalLeftSeptaeType) {
          const txt = text.PnsEthmoidalLeftSeptaeText.replace("{1}", frmData.PnsEthmoidalLeftSeptaeType);
          report += `<p><b>${txt}</b></p>`; impression.push(`<p><b>${txt}</b></p>`);
        }
        if (frmData.PnsEhtmoidalLeftVarient) {
          if (frmData.PnsEhtmoidalLeftVarientHaller) { report += "<p><b>Haller cells present on left side.</b></p>"; impression.push("<p><b>Haller cells present on left side.</b></p>"); }
          if (frmData.PnsEhtmoidalLeftVarientOnodi) { report += "<p><b>Onodi cells present on left side.</b></p>"; impression.push("<p><b>Onodi cells present on left side.</b></p>"); }
        }
      }
    }

    // Sphenoid
    if (frmData.PnsSphenoid) {
      if (frmData.PnsSphenoidRight) {
        if (frmData.PnsSphenoidRightPneumatization && frmData.PnsSphenoidRightPneumatizationtype) {
          const txt = text.PnsSphenoidRightPneumatizationText.replace("{1}", frmData.PnsSphenoidRightPneumatizationtype);
          report += `<p><b>${txt}</b></p>`; impression.push(`<p><b>${txt}</b></p>`);
        }
        if (frmData.PnsSphenoidRightMusocalThicking && frmData.PnsSphenoidRightMusocalThickingType) {
          let txt = text.PnsSphenoidRightMusocalThickingText.replace("{1}", frmData.PnsSphenoidRightMusocalThickingType);
          if (frmData.PnsSphenoidRightHyperdense) txt += " with hyperdense.";
          report += `<p><b>${txt}</b></p>`; impression.push(`<p><b>${txt}</b></p>`);
        }
        if (frmData.PnsSphenoidRightAirFluid) {
          report += "<p><b>Air fluid level seen in right sphenoid sinus.</b></p>"; impression.push("<p><b>Air fluid level seen in right sphenoid sinus.</b></p>");
        }
        if (frmData.PnsSphenoidRightEthmoid && frmData.PnsSphenoidRightEthmoidType) {
          const dict = {'patent': 'Sphenoid-ethmoid recess is patent in right frontal sinus.', 'partial narrowing': 'There is partial narrowing of right sphenoid-ethmoid recess.', 'complete occlusion': 'Complete occlusion of right sphenoid-ethmoid recess seen. '};
          const val = dict[frmData.PnsSphenoidRightEthmoidType];
          if (val) { report += `<p><b>${val}</b></p>`; impression.push(`<p><b>${val}</b></p>`); }
        }
        if (frmData.PnsSphenoidRightBonyErosions) {
          report += "<p><b>Erosions seen in bony walls of right sphenoid sinus.</b></p>"; impression.push("<p><b>Erosions seen in bony walls of right sphenoid sinus.</b></p>");
        }
      }
      if (frmData.PnsSphenoidLeft) {
        if (frmData.PnsSphenoidLeftPneumatization && frmData.PnsSphenoidLeftPneumatizationtype) {
          const txt = text.PnsSphenoidLeftPneumatizationText.replace("{1}", frmData.PnsSphenoidLeftPneumatizationtype);
          report += `<p><b>${txt}</b></p>`; impression.push(`<p><b>${txt}</b></p>`);
        }
        if (frmData.PnsSphenoidLeftMusocalThicking && frmData.PnsSphenoidLeftMusocalThickingType) {
          let txt = text.PnsSphenoidLeftMusocalThickingText.replace("{1}", frmData.PnsSphenoidLeftMusocalThickingType);
          if (frmData.PnsSphenoidLeftHyperdense) txt += " with hyperdense.";
          report += `<p><b>${txt}</b></p>`; impression.push(`<p><b>${txt}</b></p>`);
        }
        if (frmData.PnsSphenoidLeftAirFluid) {
          report += "<p><b>Air fluid level seen in left sphenoid sinus.</b></p>"; impression.push("<p><b>Air fluid level seen in left sphenoid sinus.</b></p>");
        }
        if (frmData.PnsSphenoidLeftEthmoid && frmData.PnsSphenoidLeftEthmoidType) {
          const dict = {'patent': 'Sphenoid-ethmoid recess is patent in left frontal sinus.', 'partial narrowing': 'There is partial narrowing of left sphenoid-ethmoid recess.', 'complete occlusion': 'Complete occlusion of left sphenoid-ethmoid recess seen.'};
          const val = dict[frmData.PnsSphenoidLeftEthmoidType];
          if (val) { report += `<p><b>${val}</b></p>`; impression.push(`<p><b>${val}</b></p>`); }
        }
        if (frmData.PnsSphenoidLeftBonyErosions) {
          report += "<p><b>Erosions seen in bony walls of left sphenoid sinus.</b></p>"; impression.push("<p><b>Erosions seen in bony walls of left sphenoid sinus.</b></p>");
        }
      }
    }
  }

  // Nasal Cavity
  if (frmData.NasalCavity) {
    if (frmData.DNSNasalCavity) {
      const type = frmData.DNSNasalCavityType === 'With bony spur' ? 'with bony spur.' : 'seen.';
      const dict = {'right': `DNS toward right seen ${type}`, 'left': `DNS toward left seen ${type}`, "'S' shaped": `DNS 'S' shaped seen ${type}`};
      const val = dict[frmData.DNSNasalCavityWithWithoutType];
      if (val) { report += `<p><b>${val}</b></p>`; impression.push(`<p><b>${val}</b></p>`); }
    }
    
    if (frmData.TurbinatesNasalCavity) {
      if (frmData.TurbinatesNasalRight) {
        if (frmData.TurbinatesNasalRightMiddle) {
          if (frmData.TurbinatesNasalRightConcha && frmData.TurbinatesNasalRightConchaType) {
            const txt = text.TurbinatesNasalRightConchaText.replace("{1}", frmData.TurbinatesNasalRightConchaType);
            report += `<p><b>${txt}</b></p>`; impression.push(`<p><b>${txt}</b></p>`);
          }
          if (frmData.TurbinatesNasalRightHypertrophied) { report += "<p><b>There is hypertrophied right middle turbinate.</b></p>"; impression.push("<p><b>There is hypertrophied right middle turbinate.</b></p>"); }
          if (frmData.TurbinatesNasalRightParadoxical) { report += "<p><b>Paradoxical right middle turbinate is seen.</b></p>"; impression.push("<p><b>Paradoxical right middle turbinate is seen.</b></p>"); }
        }
        if (frmData.TurbinatesNasalRightInferior && frmData.TurbinatesNasalRightInferiorHypertrophied) {
          report += "<p><b>There is hypertrophied right inferior turbinate.</b></p>"; impression.push("<p><b>There is hypertrophied right inferior turbinate.</b></p>");
        }
      }
      if (frmData.TurbinatesNasalLeft) {
        if (frmData.TurbinatesNasalLeftMiddle) {
          if (frmData.TurbinatesNasalLeftConcha && frmData.TurbinatesNasalLeftConchaType) {
            const txt = text.TurbinatesNasalLeftConchaText.replace("{1}", frmData.TurbinatesNasalLeftConchaType);
            report += `<p><b>${txt}</b></p>`; impression.push(`<p><b>${txt}</b></p>`);
          }
          if (frmData.TurbinatesNasalLeftHypertrophied) { report += "<p><b>There is hypertrophied left middle turbinate.</b></p>"; impression.push("<p><b>There is hypertrophied left middle turbinate.</b></p>"); }
          if (frmData.TurbinatesNasalLeftParadoxical) { report += "<p><b>Paradoxical left middle turbinate is seen.</b></p>"; impression.push("<p><b>Paradoxical left middle turbinate is seen.</b></p>"); }
        }
        if (frmData.TurbinatesNasalLeftInferior && frmData.TurbinatesNasalLeftInferiorHypertrophied) {
          report += "<p><b>There is hypertrophied left inferior turbinate.</b></p>"; impression.push("<p><b>There is hypertrophied left inferior turbinate.</b></p>");
        }
      }
    }

    if (frmData.TurbinatesNasalLeftMiddle && !frmData.TurbinatesNasalRightMiddle && !(frmData.TurbinatesNasalLeftConcha && frmData.TurbinatesNasalLeftHypertrophied && frmData.TurbinatesNasalLeftParadoxical)) {
      report += "<p>Rest of the middle turbinates are normal.</p>";
    }
    if (frmData.TurbinatesNasalRightMiddle && !frmData.TurbinatesNasalLeftMiddle && !(frmData.TurbinatesNasalRightConcha && frmData.TurbinatesNasalRightHypertrophied && frmData.TurbinatesNasalRightParadoxical)) {
      report += "<p>Rest of the middle turbinates are normal.</p>";
    }

    if (frmData.NasalMusocalThicking) {
      if (frmData.NasalMusocalThickingRight) { report += "<p><b>Mucosal thickening seen in right nasal cavity.</b></p>"; impression.push("<p><b>Mucosal thickening seen in right nasal cavity.</b></p>"); }
      if (frmData.NasalMusocalThickingLeft) { report += "<p><b>Mucosal thickening seen in left nasal cavity.</b></p>"; impression.push("<p><b>Mucosal thickening seen in left nasal cavity.</b></p>"); }
    }
  }

  // Miscellaneous
  if (frmData.Miscellaneous) {
    if (frmData.MiscellaneousTypeKeros && frmData.MiscellaneousTypeKerosType) {
      const txt = text.MiscellaneousTypeKerosText.replace("{1}", frmData.MiscellaneousTypeKerosType);
      report += `<p><b>${txt}</b></p>`; impression.push(`<p><b>${txt}</b></p>`);
    }
    if (frmData.MiscellaneousTypeOpticNerve && frmData.MiscellaneousTypeOpticNerveType) {
      const txt = text.MiscellaneousTypeOpticNerveText.replace("{1}", frmData.MiscellaneousTypeOpticNerveType);
      report += `<p><b>${txt}</b></p>`; impression.push(`<p><b>${txt}</b></p>`);
    }

    if (frmData.MiscellaneousbonyPneumatization) {
      if (frmData.MiscellaneousbonyPneumatizationRight) {
        if (frmData.MiscellaneousbonyPneumatizationAnteriorRight) { report += "<p><b>Pneumatization of anterior clinoid process seen on right side.</b></p>"; impression.push("<p><b>Pneumatization of anterior clinoid process seen on right side.</b></p>"); }
        if (frmData.MiscellaneousbonyPneumatizationPterygoidRight) { report += "<p><b>Pneumatization of pterygoid plate seen on right side.</b></p>"; impression.push("<p><b>Pneumatization of pterygoid plate seen on right side.</b></p>"); }
      }
      if (frmData.MiscellaneousbonyPneumatizationLeft) {
        if (frmData.MiscellaneousbonyPneumatizationAnteriorLeft) { report += "<p><b>Pneumatization of anterior clinoid process seen on left side.</b></p>"; impression.push("<p><b>Pneumatization of anterior clinoid process seen on left side.</b></p>"); }
        if (frmData.MiscellaneousbonyPneumatizationPterygoidLeft) { report += "<p><b>Pneumatization of pterygoid plate seen on left side.</b></p>"; impression.push("<p><b>Pneumatization of pterygoid plate seen on left side.</b></p>"); }
      }
    }

    if (frmData.MiscellaneousAdenoid && frmData.MiscellaneousAdenoidyesType) {
      const txt = text.MiscellaneousAdenoidyesText.replace("{1}", frmData.MiscellaneousAdenoidyesType);
      report += `<p><b>${txt}</b></p>`; impression.push(`<p><b>${txt}</b></p>`);
    }

    if (frmData.MiscellaneousMastoid) {
      if (frmData.MiscellaneousMastoidRight && frmData.MiscellaneousMastoidRightSoftTissue) {
        if (frmData.MiscellaneousMastoidRightSoftTissueType === 'partial') { report += "<p><b>Soft tissue density seen in some of the right mastoid air cells.</b></p>"; impression.push("<p><b>Soft tissue density seen in some of the right mastoid air cells.</b></p>"); }
        if (frmData.MiscellaneousMastoidRightSoftTissueType === 'complete') { report += "<p><b>Soft tissue density seen in all the right mastoid air cells.</b></p>"; impression.push("<p><b>Soft tissue density seen in all the right mastoid air cells.</b></p>"); }
      }
      if (frmData.MiscellaneousMastoidLeft && frmData.MiscellaneousMastoidLeftSoftTissue) {
        if (frmData.MiscellaneousMastoidLeftSoftTissueType === 'partial') { report += "<p><b>Soft tissue density seen in some of the left mastoid air cells.</b></p>"; impression.push("<p><b>Soft tissue density seen in some of the left mastoid air cells.</b></p>"); }
        if (frmData.MiscellaneousMastoidLeftSoftTissueType === 'complete') { report += "<p><b>Soft tissue density seen in all the left mastoid air cells.</b></p>"; impression.push("<p><b>Soft tissue density seen in all the left mastoid air cells.</b></p>"); }
      }
    }

    if (frmData.MiscellaneousPosterior) {
      if (frmData.MiscellaneousPosteriorRight && frmData.MiscellaneousPosteriorStenosisRight) {
        if (frmData.MiscellaneousPosteriorStenosisRightType === 'bony') { report += "<p><b>Bony stenosis of right posterior choana seen.</b></p>"; impression.push("<p><b>Bony stenosis of right posterior choana seen.</b></p>"); }
        if (frmData.MiscellaneousPosteriorStenosisRightType === 'membranous') { report += "<p><b>Membranous stenosis of right posterior choana seen.</b></p>"; impression.push("<p><b>Membranous stenosis of right posterior choana seen.</b></p>"); }
      }
      if (frmData.MiscellaneousPosteriorLeft && frmData.MiscellaneousPosteriorStenosisLeft) {
        if (frmData.MiscellaneousPosteriorStenosisLeftType === 'bony') { report += "<p><b>Bony stenosis of left posterior choana seen.</b></p>"; impression.push("<p><b>Bony stenosis of left posterior choana seen.</b></p>"); }
        if (frmData.MiscellaneousPosteriorStenosisLeftType === 'membranous') { report += "<p><b>Membranous stenosis of left posterior choana seen.</b></p>"; impression.push("<p><b>Membranous stenosis of left posterior choana seen.</b></p>"); }
      }
    }

    if (frmData.MiscellaneousOsteoma) {
      if (frmData.MiscellaneousOsteomaRight) {
        let arr = [];
        if (frmData.MiscellaneousOsteomaRightFrontal) arr.push('frontal');
        if (frmData.MiscellaneousOsteomaRightEthmoidal) arr.push('ethmoidal');
        if (frmData.MiscellaneousOsteomaRightMaxillary) arr.push('maxillary');
        if (frmData.MiscellaneousOsteomaRightSphenoid) arr.push('sphenoid');
        const txt = text.OsteomaText.replace("{1}", arr.join(', ')).replace("{2}", frmData.MiscellaneousOsteomaRightText);
        report += `<p><b>${txt}</b></p>`; impression.push(`<p><b>${txt}</b></p>`);
      }
      if (frmData.MiscellaneousOsteomaLeft) {
        let arr = [];
        if (frmData.MiscellaneousOsteomaLeftFrontal) arr.push('frontal');
        if (frmData.MiscellaneousOsteomaLeftEthmoidal) arr.push('ethmoidal');
        if (frmData.MiscellaneousOsteomaLeftMaxillary) arr.push('maxillary');
        if (frmData.MiscellaneousOsteomaLeftSphenoid) arr.push('sphenoid');
        const txt = text.OsteomaText1.replace("{1}", arr.join(', ')).replace("{2}", frmData.MiscellaneousOsteomaLeftText);
        report += `<p><b>${txt}</b></p>`; impression.push(`<p><b>${txt}</b></p>`);
      }
    }

    if (frmData.MiscellaneousMucocele) {
      if (frmData.MiscellaneousMucoceleRight) {
        let arr = [];
        if (frmData.MiscellaneousMucoceleRightFrontal) arr.push('frontal');
        if (frmData.MiscellaneousMucoceleRightEthmoidal) arr.push('ethmoidal');
        if (frmData.MiscellaneousMucoceleRightMaxillary) arr.push('maxillary');
        if (frmData.MiscellaneousMucoceleRightSphenoid) arr.push('sphenoid');
        const txt = text.MucoceleText.replace("{1}", arr.join(', ')).replace("{2}", frmData.MiscellaneousMucoceleRightText);
        report += `<p><b>${txt}</b></p>`; impression.push(`<p><b>${txt}</b></p>`);
      }
      if (frmData.MiscellaneousMucoceleLeft) {
        let arr = [];
        if (frmData.MiscellaneousMucoceleLeftFrontal) arr.push('frontal');
        if (frmData.MiscellaneousMucoceleLeftEthmoidal) arr.push('ethmoidal');
        if (frmData.MiscellaneousMucoceleLeftMaxillary) arr.push('maxillary');
        if (frmData.MiscellaneousMucoceleLeftSphenoid) arr.push('sphenoid');
        const txt = text.MucoceleText1.replace("{1}", arr.join(', ')).replace("{2}", frmData.MiscellaneousMucoceleLeftText);
        report += `<p><b>${txt}</b></p>`; impression.push(`<p><b>${txt}</b></p>`);
      }
    }
  }

  // NORMAL FALLBACK CHECKS
  if (!frmData.PnsFrontalRightAirFluid && !frmData.PnsFrontalLeftAirFluid && !frmData.PnsMaxillaryRightAirFluid && !frmData.PnsMaxillaryLeftAirFluid && !frmData.PnsEthmoidalRightAirFluid && !frmData.PnsEthmoidalLeftAirFluid && !frmData.PnsSphenoidRightAirFluid && !frmData.PnsSphenoidLeftAirFluid && !frmData.Normalsinus) {
    report += "<p>No air fluid levels seen in both frontal, maxillary, ethmoidal, sphenoid sinus.</p>";
  }

  if (!frmData.PnsFrontalRightBonyErosions && !frmData.PnsFrontalLeftBonyErosions && !frmData.PnsMaxillaryRightBonyErosions && !frmData.PnsMaxillaryLeftBonyErosions && !frmData.PnsEthmoidalRightBonyErosions && !frmData.PnsEthmoidalLeftBonyErosions && !frmData.PnsSphenoidRightBonyErosions && !frmData.PnsSphenoidLeftBonyErosions && !frmData.Normalsinus) {
    report += "<p>No bony erosion seen.</p>";
  }

  if (!frmData.TurbinatesNasalCavity && !frmData.Normalsinus) {
    report += "<p>Middle and inferior turbinate are normal on both sides.</p>";
  } else {
    if (!frmData.TurbinatesNasalLeftMiddle && frmData.TurbinatesNasalRightMiddle && !frmData.Normalsinus) report += "<p>Middle turbinate are normal on left side.</p>";
    if (!frmData.TurbinatesNasalRightMiddle && frmData.TurbinatesNasalLeftMiddle && !frmData.Normalsinus) report += "<p>Middle turbinate are normal on right side.</p>";
    if (frmData.TurbinatesNasalRight || frmData.TurbinatesNasalLeft) {
      if (!frmData.TurbinatesNasalLeftInferior && !frmData.TurbinatesNasalRightInferior) report += "<p>Inferior turbinate are normal on both sides.</p>";
      if (!frmData.TurbinatesNasalLeftMiddle && !frmData.TurbinatesNasalRightMiddle) report += "<p>Middle turbinate are normal on both sides.</p>";
    }
    if (!frmData.TurbinatesNasalRightInferior && frmData.TurbinatesNasalLeftInferior && !frmData.Normalsinus) report += "<p>Inferior turbinate is normal on right side.</p>";
    if (!frmData.TurbinatesNasalLeftInferior && frmData.TurbinatesNasalRightInferior && !frmData.Normalsinus) report += "<p>Inferior turbinate is normal on left side.</p>";
  }

  if (!frmData.MiscellaneousMastoid && !frmData.Normalsinus) report += "<p>Mastoid air cells are normal on both sides.</p>";
  if (!frmData.MiscellaneousPosterior && !frmData.Normalsinus) report += "<p>Posterior choana is normal on both sides.</p>";

  // PAGE BREAK
  report += `<div class="page-break ck-widget ck-widget_selected" contenteditable="false" draggable="true"></div>`;

  // IMPRESSION & SIGNATURE
  report += `
    <p><strong>IMPRESSION:</strong></p>
    <p>${impression.length > 0 ? impression.join("") : "<strong>• No significant abnormality in the paranasal sinuses.</strong>"}</p>
  `;

  if (currentUser) {
    report += `
      <p>
        <br>
        <img src="${currentUser.signature}" height="75" />
        <br>${currentUser.full_name}<br>${currentUser.designation}
      </p>
    `;
  }

  return report;
}